<template>
  <svg
    version="1.1"
    id="Laag_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 40 40"
    style="enable-background: new 0 0 40 40"
    xml:space="preserve">
    <style type="text/css">
      .st0 {
        fill: url(#SVGID_1_);
      }
      .st1 {
        fill: none;
        stroke: #ffffff;
        stroke-width: 2.196;
        stroke-linecap: round;
        stroke-linejoin: round;
      }
    </style>
    <g id="Logo_wit">
      <g id="Laag_2_kopie_2">
        <g>
          <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1="20"
            y1="39.9879"
            x2="20"
            y2="4.0121"
            gradientTransform="matrix(1 0 0 -1 0 42)">
            <stop offset="0" style="stop-color: #e5087e" />
            <stop offset="1" style="stop-color: #29265b" />
          </linearGradient>
          <path
            class="st0"
            d="M31.3,6.6l-0.1,26.8c0,3.5-3.8,5.7-6.9,3.9l-14.2-9.2c-1-0.6-1.6-1.7-1.6-2.9v-9.8c0-1.7,0.8-3.2,2.3-4.1
				l13.6-8.8C27.5,0.9,31.3,3.1,31.3,6.6L31.3,6.6z" />
          <path
            class="st1"
            d="M12.2,15.6c3.7-4.3,8.1-6,10.9-6.8C37.6,6,12.2,29.6,12.2,25.6v-6.9c0,0,14.9,6.9,14.9,15.9" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ProjectLogo",
};
</script>
